var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-header"},[(_vm.loginLevel > 0)?_c('div',[_c('CommonMenu')],1):_c('div',[_c('CommonPublic')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }